import AdalErrorCode from '../schema/AdalErrorCode';
import { SsoErrorCode } from '../schema/SsoErrorCode';

export default function mapAdalErrorToSsoApiError(errorMessage: string): SsoErrorCode {
    let errorCode = SsoErrorCode.InternalError;

    if (errorMessage && errorMessage.indexOf(AdalErrorCode.NoUserLogin) >= 0) {
        errorCode = SsoErrorCode.UserNotSignedIn;
    } else if (errorMessage && errorMessage.indexOf(AdalErrorCode.InvalidResourceUrl) >= 0) {
        errorCode = SsoErrorCode.InvalidResourceUrl;
    } else if (errorMessage && errorMessage.indexOf(AdalErrorCode.InvalidGrant) >= 0) {
        errorCode = SsoErrorCode.InvalidGrant;
    }

    return errorCode;
}
